// src/views/dashboard/rwa/components/RWADataPageEdit.jsx
import { useEffect, useState } from "react";
import { Button } from "@oc-labs/wt-storybook";
import ModalV2 from "../../../../components/ModalV2";
import useModal from "../../../../hooks/useModal";
import useMultimedia from "../../../../hooks/useMultimedia";
import useRwas from "../../../../hooks/useRwas";
import useCompany from "../../../../hooks/useCompany";
import toast from "react-hot-toast";
import EditableImage from "../../../../components/EditableImage";
import TextEditor from "../../../../components/TextEditor";

export default function RWADataPageEditModal({ rwa, reloadRwa }) {
  const { activeCompany: company } = useCompany();
  const { modal, isOpen, close } = useModal("rwa-edit-param-page-modal");
  const { upload } = useMultimedia();
  const { updateRwaDataPage } = useRwas();
  const paramKey = modal?.props;
  const pageData = rwa?.rwa_data?.find((d) => d.key === paramKey)?.rwa_data_page || null;
  const [value, setValue] = useState("");
  const [imagePreview, setImagePreview] = useState(null); 
  const [file, setFile] = useState(null);                  

  useEffect(() => {
    if (!isOpen || !paramKey) return;
    setValue(pageData?.value || "");
    setImagePreview(pageData?.image || null);
    setFile(null);
  }, [isOpen, paramKey, pageData?.value, pageData?.image]);

  const paramKeyFormatted = paramKey
    ? paramKey.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase().replace(/^./, (s) => s.toUpperCase())
    : "";

  const handleImageChange = (next) => {
    if (!next) {
      setFile(null);
      setImagePreview(null);
      return;
    }
    setFile(next);
    setImagePreview(URL.createObjectURL(next));
  };

  const handleUpsert = async () => {
    try {
      if(!value) return toast.error("Please add some text before saving this page.");
      let finalImage = pageData?.image ?? null;
      if (file) finalImage = await upload(file);
      if (imagePreview === null) finalImage = null;

      await updateRwaDataPage(company.id, rwa.id, {
        rwaDataKey: paramKey,
        pageType: "html", 
        value: value ?? "",
        image: finalImage,
      });

      toast.success(`Successfully updated ${paramKeyFormatted} page for ${rwa.name}`);
      reloadRwa && reloadRwa(); 
      close();
    } catch (error) {
      console.error("Error updating RWA data page:", error);
      toast.error(`Failed to update ${paramKeyFormatted} page for ${rwa.name}`);
    }
  };

  if (!isOpen) return null;

  return (
    <ModalV2
      name="rwa-edit-param-page-modal"
      className="min-w-[800px]"
      title={`Edit ${paramKeyFormatted} page for ${rwa?.name}`}
    >
      <EditableImage
        base64={false}
        image={imagePreview}
        onImageChange={handleImageChange} 
      />

      <div className="w-full border border-gray-300 rounded-md p-4 mt-4">
        <TextEditor open={paramKey} initialContent={pageData?.value} setValue={setValue} />
      </div>

      <Button className="mt-4" onClick={handleUpsert} variant="primary">
        Save
      </Button>
    </ModalV2>
  );
}
